import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { Component } from '../../utils/Component';
import { ValidatingFormContext } from '../../validatingElements';

interface ITotalRiskScoreProps extends ITranslateProps {
    step: 'analysis' | 'verification' | 'maintenance';
}

class TotalRiskScoreComponent extends Component<ITotalRiskScoreProps, Record<string, unknown>> {
    public override render() {
        return (
            <ValidatingFormContext.Consumer>
                {(validatingForm) => {
                    if (
                        this.props.step === 'analysis' &&
                        validatingForm.item.analysisRamsWeightedPriority &&
                        validatingForm.item.analysisRamsWeightedPriority !== '0'
                    ) {
                        return (
                            <span className={`label p5 fs12 rams_result${validatingForm.item.analysisRamsWeightedPriority}`}>
                                {' '}
                                {this.props.t(`fmecaRisk.${validatingForm.item.analysisRamsWeightedPriority}`)}&nbsp;(
                                {validatingForm.item.analysisRamsTotalPriority}){' '}
                            </span>
                        );
                    }

                    if (
                        this.props.step === 'verification' &&
                        validatingForm.item.verificationRamsWeightedPriority &&
                        validatingForm.item.verificationRamsWeightedPriority !== '0'
                    ) {
                        return (
                            <span className={`label p5 fs12 rams_result${validatingForm.item.verificationRamsWeightedPriority}`}>
                                {' '}
                                {this.props.t(`fmecaRisk.${validatingForm.item.verificationRamsWeightedPriority}`)}&nbsp;(
                                {validatingForm.item.verificationRamsTotalPriority}){' '}
                            </span>
                        );
                    }

                    if (
                        this.props.step === 'maintenance' &&
                        validatingForm.item.maintenanceRamsWeightedPriority &&
                        validatingForm.item.maintenanceRamsWeightedPriority !== '0'
                    ) {
                        return (
                            <span className={`label p5 fs12 rams_result${validatingForm.item.maintenanceRamsWeightedPriority}`}>
                                {' '}
                                {this.props.t(`fmecaRisk.${validatingForm.item.maintenanceRamsWeightedPriority}`)}&nbsp;(
                                {validatingForm.item.maintenanceRamsTotalPriority}){' '}
                            </span>
                        );
                    }
                    return null;
                }}
            </ValidatingFormContext.Consumer>
        );
    }
}
// eslint-disable-next-line @typescript-eslint/naming-convention
export const TotalRiskScore = translate()(TotalRiskScoreComponent);
